// The confirm gate for leaving a live brainstorm. Mounted once at the app root;
// it subscribes to the leave guard and shows whenever a navigation away from a
// live session is pending (leaveGuard.ts). Confirming lets the navigation
// proceed — which unmounts/swaps the session controller and ends the gateway
// round (the agent stops listening). Cancelling keeps you in the room.

import { useSyncExternalStore } from 'react'
import { Button } from '@/components/ui/Button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/ui/Dialog'
import {
  hasPendingLeave,
  resolveLeave,
  subscribeLeaveGuard
} from '@/lib/session/leaveGuard'

export function LeaveGuardDialog() {
  const open = useSyncExternalStore(subscribeLeaveGuard, hasPendingLeave)
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) resolveLeave(false)
      }}
    >
      <DialogContent showCloseButton={false}>
        <DialogHeader>
          <DialogTitle>Leave this session?</DialogTitle>
          <DialogDescription>
            Your Claude Code participant is listening to this room. Leaving ends
            the brainstorm — Claude stops listening and won’t follow you. You can
            start a fresh one with <code>/brainstorm</code> any time.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => resolveLeave(false)}>
            Stay
          </Button>
          <Button variant="destructive" onClick={() => resolveLeave(true)}>
            Leave &amp; end
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
